import { Image, ImageProps, useBreakpoint } from '@gyym/ui'
import React, { useEffect, useMemo, useState } from 'react'

import { BaseImageSwapper, Container, ImageWrapper } from './styles'

export interface ImageSwapperImage {
  pc: ImageProps
  sp: ImageProps
}

export interface ImageSwapperProps {
  /**
   * Array of images
   */
  imageMap: ImageSwapperImage[]

  /**
   * Image swap interval in ms
   */
  swapMs?: number
}

/**
 * ImageSwapper component
 */
export const ImageSwapper = ({
  imageMap,
  swapMs = 5000,
}: ImageSwapperProps) => {
  const { isPc } = useBreakpoint()

  const [currentIndex, setCurrentIndex] = useState(0)

  // Get the previous index
  const prevIndex = useMemo(() => {
    return imageMap[currentIndex - 1] ? currentIndex - 1 : imageMap.length - 1
  }, [currentIndex, imageMap])

  // Switch current background by interval
  useEffect(() => {
    if (typeof window === 'undefined') return

    const timerId = setInterval(() => {
      setCurrentIndex((i) => (i < imageMap.length - 1 ? i + 1 : 0))
    }, swapMs)

    return () => clearInterval(timerId)
  }, [imageMap, swapMs])

  return (
    <Container>
      {imageMap.map(({ pc, sp }, i) => (
        <BaseImageSwapper
          key={i}
          fadeIn={i === currentIndex}
          fadeOut={i === prevIndex}
        >
          <ImageWrapper>
            <Image
              {...(isPc ? pc : sp)}
              loading={i === 0 ? 'eager' : 'lazy'}
              priority={i === 0}
              style={{
                objectFit: 'cover',
                objectPosition: 'center',
              }}
            />
          </ImageWrapper>
        </BaseImageSwapper>
      ))}
    </Container>
  )
}
